"use strict";

import React, {useContext, useRef,} from 'react';
import Icon from "../../component/Icon";
import AccountEcheckCreateAlternativeContext from "../context/AccountEcheckCreateAlternativeContext";
import AccountEchecksCreateFinancialAccount from "./AccountEchecksCreateFinancialAccount";
import AccountEchecksCreateAuthorize from "./AccountEchecksCreateAuthorize";
import AccountEchecksCreateTermsOfServiceForm from "./AccountEchecksCreateTermsOfServiceForm";
import Panel from "../../component/Panel";

const AccountEchecksCreatePreScreen = ({isFetchingAccount=false, userAddress={}, email=''}) => {
    const stepsHeaderRef = useRef();
    const {
        errors= {},
        currentStep=0,
        authorizedEchecks=[],
        financialAccountData={},
        authorizeData={},
        termsOfServiceData={},
        handleFinancialAccountSubmit=()=>{},
        handleAuthorizeSubmit=()=>{},
        handleTermsOfServiceSubmit=()=>{},
        handleCreateEcheckSubmit=()=>{},
        isCreatingEcheck=false,
    } = useContext(AccountEcheckCreateAlternativeContext);

    function onFinancialAccountSubmit(data) {
        handleFinancialAccountSubmit(data);
    }

    function onAuthorizeSubmit(data) {
        handleAuthorizeSubmit(data)
    }

    function onTermsOfServiceSubmit(data) {
        handleTermsOfServiceSubmit(data)
    }

    function onCreateEcheckSubmit(e){
        e.preventDefault();
        if(!isCreatingEcheck)
            handleCreateEcheckSubmit();
    }

    return (
        <React.Fragment>
            <h3>Create Your Tangible Values E-Check Authorization</h3>

            {!!authorizedEchecks && !!authorizedEchecks.length &&
                <Panel className="panel" type="warning" iconName="caution" >
                    <React.Fragment>
                        <strong>Caution:</strong>
                        If you create a new Tangible Values
                        E-check your currently active
                        Tangible Values E-check will be revoked.
                    </React.Fragment>
                </Panel>
            }

            <p><strong>Here's how the Tangible Values E-Check works:</strong> You authorize payments to be made from your
                checking or savings account at the time you place an order with Tangible Values. Your payments will then be
                made automatically from your authorized bank account in a timely manner (usually 2-4 days after
                placing your order). A proof of payment will appear on both your Tangible Values invoice as well as the
                statement you receive from your financial institution.</p>
            <p>The Tangible Values E-Check is secure, dependable, flexible, convenient and easy to use. To take advantage of
                this service, complete the 3 easy steps below.</p>

            <div ref={stepsHeaderRef} className="steps is-small is-bordered has--margin-bottom">
                <div className={`step-item ${currentStep === 0 ? 'is-active' : currentStep > 0 ? 'is-completed is-success' : ''}`}>
                    <div className="step-marker">1</div>
                    <div className="step-details">
                        <p className="is-marginless">Account Details</p>
                    </div>
                </div>
                <div className={`step-item ${currentStep === 1 ? 'is-active' : currentStep > 0 ? 'is-completed is-success' : ''}`}>
                    <div className="step-marker">1</div>
                    <div className="step-details">
                        <p className="is-marginless">Authorize</p>
                    </div>
                </div>
                <div className={`step-item ${currentStep === 2 ? 'is-active' : currentStep > 1 ? 'is-completed is-success' : ''}`}>
                    <div className="step-marker">2</div>
                    <div className="step-details">
                        <p className="is-marginless">Terms of Service</p>
                    </div>
                </div>
                <div className={`step-item ${currentStep === 3 ? 'is-active' : currentStep > 2 ? 'is-completed is-success' : ''}`}>
                    <div className="step-marker">3</div>
                    <div className="step-details">
                        <p className="is-marginless">Create</p>
                    </div>
                </div>
                <div className="steps-content is-active">
                    {currentStep === 0 &&
                        <AccountEchecksCreateFinancialAccount
                            isFetchingAccount={isFetchingAccount}
                            userAddress={userAddress}
                            email={email}
                            financialAccountData={financialAccountData}
                            onSubmit={onFinancialAccountSubmit} />
                    }
                    {currentStep === 1 &&
                        <AccountEchecksCreateAuthorize stepsHeaderOffsetTop={stepsHeaderRef.current.offsetTop}
                                                       financialAccountData={financialAccountData}
                                                       authorizeData={authorizeData}
                                                       onSubmit={onAuthorizeSubmit} />
                    }
                    {currentStep === 2 &&
                        <AccountEchecksCreateTermsOfServiceForm
                            stepsHeaderOffsetTop={stepsHeaderRef.current.offsetTop}
                            onSubmit={onTermsOfServiceSubmit}
                            formData={termsOfServiceData} />
                    }
                    {currentStep === 3 &&
                        <div>
                            { !!errors?.createEcheck &&
                                <React.Fragment>
                                    <Panel className="panel" type="error" iconName="warning" >
                                        <p className="is-marginless">
                                            <strong>Error:</strong>
                                            {errors?.createEcheck}
                                        </p>

                                    </Panel>
                                    <p className="text__center">
                                        <a href="/echeck/accounts/echecks/create"
                                           title="Please Try Again"
                                           className="btn__primary--outline btn--small">
                                            Please Try Again
                                        </a>
                                    </p>
                                </React.Fragment>
                                ||
                                <div className="text__center">
                                    {isCreatingEcheck &&
                                        <div style={{position: 'relative', maringBottom: '1rem', display: 'flex',}}>
                                            <p>Creating your E-check...</p>
                                            <div className="loading loading--cover loading--center-flex loading--w-flip" />
                                        </div>
                                    }
                                    <button type="submit"
                                            onClick={onCreateEcheckSubmit}
                                            className={`btn__primary no-wrap${
                                                isCreatingEcheck
                                                    ? ' btn--disabled'
                                                    : ''
                                            }`}
                                            disabled={isCreatingEcheck} >
                                        Create Echeck <Icon name="right" className="icon--collapse-right" />
                                    </button>
                                </div>
                            }
                        </div>

                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default AccountEchecksCreatePreScreen;
